module.exports = __webpack_public_path__ + "static/home-hero-a520ab7c8c3aa0a7f6fcdfa270099dd1.svg";